import React from "react";
import "./NailSalonTestimonial.css";

const NailSalonTestimonialHead = () => {
  return (
    <div className="nailTestimonialHeadContainer">
      <h3>Client Testimonials</h3>
      <p>
        Don’t just take our word for it—hear what our satisfied clients have to
        say about their experience at SCENT , the best nails salon in
        Bangalore:
      </p>
    </div>
  );
};

export default NailSalonTestimonialHead;
